export default __webpack_public_path__ + "static/media/digitizeRectangle.8ae03d48.cur";